import { Box } from "@mui/material";
import Paper from "@mui/material/Paper";
import type { SxProps, Theme } from "@mui/material/styles";
import type { ReactNode } from "react";
import { listPageContainerSx } from "../../lib/ui/pageLayout";

type PageListContainerProps = {
  children: ReactNode;
  /**
   * When true, grows to fill a flex parent (e.g. full-height dashboard body) so children can use height:100%.
   */
  fillHeight?: boolean;
  /**
   * When true with `fillHeight`, removes inner padding/margin so content can use the full viewport height.
   */
  flush?: boolean;
  paperSx?: SxProps<Theme>;
};

/**
 * Outlined surface + section-colored inner panel; standard wrapper for data tables and list tools.
 */
function PageListContainer({
  children,
  fillHeight = true,
  flush = false,
  paperSx,
}: PageListContainerProps) {
  return (
    <Paper
      variant="outlined"
      sx={{
        bgcolor: "background.paper",
        borderColor: "divider",
        width: "100%",
        minWidth: 0,
        ...(fillHeight
          ? {
              flex: 1,
              height: "100%",
              minHeight: 0,
              maxHeight: "100%",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }
          : {}),
        ...paperSx,
      }}
    >
      <Box
        sx={{
          ...(flush && fillHeight ? {} : listPageContainerSx),
          ...(fillHeight
            ? {
                flex: 1,
                height: "100%",
                minHeight: 0,
                maxHeight: "100%",
                display: "flex",
                flexDirection: "column",
                overflow: "auto",
                ...(flush ? { p: 0, m: 0, borderRadius: 0 } : {}),
              }
            : {}),
        }}
      >
        {children}
      </Box>
    </Paper>
  );
}

export default PageListContainer;
